module.exports = __webpack_public_path__ + "static/img/news4detail3.f4a783f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news4detail3.jpg
// module id = ZupY
// module chunks = 0